import NewCarta from "./NewCarta";

export default NewCarta;
